import { _, React, classNames, withStyles, StyledProps, CentricTheme } from '@api'
import { Placeholder } from './Placeholder'
import * as css from './GroupHeader.css'
import { Typography } from '@material-ui/core'

interface MyProps extends StyledProps {
  image?: React.ReactNode
  title?: string
  subtitle?: string
  hide?: { image?: boolean, title?: boolean, subtitle?: boolean }
}

export class GroupHeader extends React.Component<MyProps> {
  static defaultProps: Partial<MyProps> = {
    title:    'Group Name',
    subtitle: 'Subtitle',
    image:    <div className={css.placeholder}><Placeholder/></div>
  }

  render() {
    const {props: {className, classes, title, image, subtitle, hide}} = this

    return (
      <div className={classNames(className, css.root)}>
        {image && (!hide || !hide.image) && <div className={css.image}>{image}</div>}
        <div className={css.textContainer}>
          {title && (!hide || !hide.title) && <Typography className={css.title} variant='h6'>{title}</Typography>}
          {subtitle && (!hide || !hide.subtitle) && <Typography className={css.subtitle} variant='body1'>{subtitle}</Typography>}
        </div>
      </div>
    )
  }
}



// WEBPACK FOOTER //
// ./src/shared/components/ui/components/GroupHeader.tsx